import { useMemo } from "react";

import { STOP_NUMBER_MAP } from "@/constants/filters";
import { BANK_NAME_MAP, SHOW_PANORAMA_PROGRAM_NAME_MAP } from "@/constants/programs";

import { FilterOptions, OptionItem } from "../typing";

const transformerOptions = (map: Map<string, string>): OptionItem[] => {
  const options = [];
  for (const [value, label] of map.entries()) {
    options.push({ label, value });
  }

  return options;
};

const useProgramsOptions = (): OptionItem[] => {
  return useMemo(() => {
    return transformerOptions(SHOW_PANORAMA_PROGRAM_NAME_MAP).sort((a, b) => a.label.localeCompare(b.label));
  }, []);
};

const useDurationRange = (): [number, number] => {
  return useMemo(() => {
    return [0, 10000];
  }, []);
};

/**
 * 根据数据列表获取筛选项
 */
export const useFilterOptions = (): FilterOptions => {
  const programsOptions = useProgramsOptions();
  const durationRange = useDurationRange();

  return {
    programsOptions,
    stopsOptions: transformerOptions(STOP_NUMBER_MAP),
    maxPointsRange: [0, 100000],
    taxRange: [0, 10000],
    durationRange,
    banksOptions: Object.values(BANK_NAME_MAP).map((v) => ({
      value: v,
      label: v,
    })),
  };
};
